module.exports = __webpack_public_path__ + "img/love.2a7630b4.png";